export const ailIsMultiDates = ail => ail.dt_end_part1 && ail.dt_start_part1 !== ail.dt_end_part1;
